<template>
<div class="mb-4 filtergroup">
  <h4>Ownership</h4>
  <label class="block font-bold" v-for="filter in filters" :key="filter.item">
    <input class="mr-2 leading-tight" type="checkbox" :value="filter.item" v-model="checkedFilters" v-on:change="updatefilters">
    <span class="text-sm">
      {{ filter.item }}
      <!-- span class="count text-grey">(
        {{ filter.count }}
      )</span -->
    </span>
  </label>
</div>
</template>

<script>
export default {
  name: 'Ownership',
  data () {
    return {
      checkedFilters: []
    }
  },
  methods: {
    updatefilters: function (event) {
      this.$store.commit('ADD_FILTER', {
        type: 'ownership',
        filters: this.checkedFilters
      })
    }
  },
  computed: {
    filters () {
      return this.$store.getters.ownerships
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ownerships.vue